import './style/main.scss';

export class App {
    #apiUrl = null;

    init() {}

    get apiUrl() {
        return this.#apiUrl;
    }

    set apiUrl(value) {
        this.#apiUrl = value;
    }
}

export default new App();